<ng-container *ngIf="gln; else loading">
  <ng-container *ngIf="edit && !gln.isMain; else pageContent">
    <ng-container *ngIf="GLNForm; else loading">
      <ng-container [ngTemplateOutlet]="pageContent"></ng-container>
    </ng-container>
  </ng-container>
  <p *ngIf="edit" class="gs1-legal">
    Les informations recueillies ici par GS1 France font l’objet d’un traitement
    destiné à permettre l'usage de Codeonline GLN et pourront, selon les choix
    effectués sur votre interface, être transmises à des tiers, adhérents à GS1
    France.<br />
    Conformément aux dispositions de la loi n°78-17 du 6 janvier 1978 dite
    « Informatique et Libertés » modifiée, au Règlement UE 2016/679 ou à toute
    autre disposition normative qui viendrait le compléter ou s’y substituerait,
    chaque personne, dont les données personnelles sont collectées, dispose d’un
    droit d’accès, de modification, de rectification et de suppression de ces
    dernières. Toute personne dont les données personnelles sont collectées
    dispose également du droit de s’opposer, pour des motifs légitimes, à leur
    traitement. Ces droits peuvent être exercés à tout moment en adressant un
    email à
    <a href="mailto:serviceclient@gs1fr.org">serviceclient@gs1fr.org</a> ou un
    courrier à Service client GS1 France, 21 boulevard Haussmann 75009 Paris, en
    nous indiquant la raison sociale de son entreprise, sa référence adhérent,
    ses nom et prénom, accompagnés de la copie de sa pièce d’identité.<br />
    Pour plus d’information, vous pouvez consulter notre
    <a target="_blank" href="https://www.gs1.fr/politique-confidentialite">Politique de Confidentialité</a>.
  </p>
  <div *ngIf="edit && GLNForm" class="button-wrapper">
    <button gs1Button [appearance]="'outlined'" (click)="cancelEdit()">
      Annuler
    </button>
    <button gs1Button (click)="saveChanges()" [disabled]="!GLNForm.valid">
      Valider
    </button>
  </div>
</ng-container>

<ng-template #loading>
  <div class="spinner-wrapper">
    <div gs1Spinner [big]="true" size="60px"></div>
  </div>
</ng-template>

<ng-template #pageContent>
  <ng-container *ngIf="gln">
    <div class="full-width gs1-spacer-3 presentation">
      <div [ngClass]="{'full-width' : !edit}">
        <div class="card gs1-spacer-3" [ngClass]="{
          'column column-left' : !edit
        }">
          <div>
            <h3>
              GLN : {{ gln.gln
              }}<i [matTooltip]="'Copier le code GLN dans le presse papier'" [matTooltipPosition]="'above'"
                class="bi bi-clipboard gs1-little" [ngClass]="{
                  'bi-clipboard': !copied,
                  'gs1-color-link': !copied,
                  'bi-clipboard-check': copied,
                  'gs1-color-forest': copied
                }" (click)="copyGLN()"></i>
            </h3>
            <span *ngIf="!GLNForm" class="gs1-color-blue gs1-little">
              <i *ngIf="gln.isMain && !fromSearch" class="bi bi-house-door gs1-color-blue"></i>
              <i *ngIf="gln.isMain && fromSearch" class="bi bi-star gs1-color-blue"></i>
              {{ gln.name }}
            </span>
            <div [formGroup]="GLNForm" *ngIf="GLNForm && edit" class="name-input">
              <gs1-input [name]="'Name'" formControlName="name" [label]="'Nom du GLN'" class="full-width"></gs1-input>
            </div>
          </div>
          <div *ngIf="!GLNForm && !edit">
            <span *ngFor="let type of gln.glnTypes" class="gs1-small chip {{ type.toLowerCase() }}-chip">
              {{ getLabelForType(type) }}
            </span>
          </div>
          <div *ngIf="GLNForm && edit" [formGroup]="GLNForm">
            <gs1-checkbox-group [hasState]="false" [label]="'Type(s)'" formGroupName="glnType">
              <gs1-checkbox [name]="'physical'" formControlName="isFixedPhysicalLocation">
                Lieu physique
                <span class="bi bi-question-circle-fill gs1-color-blue" [matTooltipPosition]="'above'" [matTooltip]="
                    'Tous types de lieux rattachés à une adresse postale. Exemple : une usine, un site d\'entreprise, un site, etc.'
                  "></span>
              </gs1-checkbox>
              <gs1-checkbox [name]="'function'" formControlName="isFunction">
                Fonction
                <span class="bi bi-question-circle-fill gs1-color-blue" [matTooltipPosition]="'above'" [matTooltip]="
                    'Représente un service ou une fonction. Exemple : un service de facturation, une équipe, un département organisationnel, etc.'
                  ">
                </span>
              </gs1-checkbox>
              <gs1-checkbox [name]="'digital'" formControlName="isDigitalLocation">
                Lieu digital
                <span class="bi bi-question-circle-fill gs1-color-blue" [matTooltipPosition]="'above'" [matTooltip]="
                    'Une adresse digitale représentée par une url, un serveur informatique, un site internet, etc.'
                  "></span>
              </gs1-checkbox>
            </gs1-checkbox-group>
          </div>
        </div>
        <div class="other-infos">
          <div>
            <span class="gs1-color-slate gs1-small">Date de création: {{ gln.created | date : "dd/MM/yyyy" }}</span>
            <span class="gs1-color-slate gs1-small" *ngIf="gln.lastModified">Dernière modification: {{ gln.lastModified | date : "dd/MM/yyyy" }}</span>
          </div>
          <div *ngIf="!GLNForm && !fromSearch">
            <span class="gs1-little gepir-status"><i
                class="bi bi-cloud-{{ gln.isPublished ? 'check' : 'slash' }}"></i>Publié<i
                class="bi bi-question-circle-fill gs1-color-blue"
                matTooltip="La publication rend le GLN visible sur les registres GS1 ainsi que les données à caractère personnel renseignées."
                [matTooltipPosition]="'above'"></i>
            </span>
          </div>
          <div *ngIf="GLNForm && !fromSearch" [formGroup]="GLNForm">
            <gs1-toggle [color]="'green'" formControlName="isPublished" ngDefaultControl [name]="'isPublished'">
              <span>Publié
                <i class="bi bi-question-circle-fill gs1-color-blue"
                  matTooltip="La publication rend le GLN visible sur les registres GS1 ainsi que les données à caractère personnel renseignées."
                  [matTooltipPosition]="'above'"></i>
                </span>
            </gs1-toggle>
          </div>

          <span class="gs1-small gs1-spacer-3" *ngIf="!GLNForm">
            {{gln.language ? "Langue - " + gln.language.toUpperCase() : ""}}
          </span>
          <gs1-select-wrapper [hasState]="false" *ngIf="GLNForm" [formGroup]="GLNForm">
            <label for="language">Langue du GLN</label>
            <ng-select formControlName="language" name="language" [bindValue]="'value'" [bindLabel]="'fr'"
              [notFoundText]="'Aucun résultat trouvé'" [clearable]="false" [hideSelected]="true" [items]="languages"
              [searchable]="true" [multiple]="false" [closeOnSelect]="true">
            </ng-select>
          </gs1-select-wrapper>
        </div>
      </div>
      <div>
        <button *ngIf="!fromSearch && gln.isActive && !gln.isMain && admin && !edit" gs1Button
          class="edit-button gs1-spacer-5" (click)="startEdition()" [thin]="true" [appearance]="'outlined'">
          Modifier
        </button>
      </div>
    </div>
    <div *ngIf="!gln.isMain" class="gln-parents gs1-spacer-3">
      <div class="gln-parent gs1-background-color-ui-4">
        <span class="gs1-little gs1-color-blue">GLN principal associé</span>
        <a (click)="navigateToMainGLN()" class="gs1-little"><span>{{ gln.mainGln }}</span><span>&nbsp;({{ gln.companyName }})</span></a>
      </div>
      <div class="gln-parent gs1-background-color-ui-4" *ngIf="!edit && gln.parentOrganisationGLN">
        <span class="gs1-little gs1-color-blue">GLN parent associé</span>
        <span class="gs1-little gs1-color-blue">{{ gln.parentOrganisationGLN }}</span>
      </div>
      <div class="gln-parent" *ngIf="edit && GLNForm && gln.parentOrganisationGLN" [formGroup]="GLNForm">
        <gs1-input [hasState]="false" [label]="'GLN parent associé'" [name]="'glnParent'" formControlName="parentOrganisationGLN">
        </gs1-input>
      </div>
    </div>
    <div class="columns full-width">
      <div class="column"
      [ngClass]="{
        'column-left' : !edit
      }">

        <gs1-form-group [hasState]="false" [label]="'Localisation'" *ngIf="
            (gln.address &&
              (!!gln.address.streetAddress ||
                !!gln.address?.countryCode ||
                !!gln.address?.postalCode ||
                !!gln.address?.addressLocality)) ||
            gln.digitalAddress ||
            gln.url
          ">
          <div style="display: flex;" class="full-width row">
          <div class="gs1-form-group-part col-5" style="display:inline-block;" *ngIf="
              !GLNForm &&
              gln.address &&
              (!!gln.address.streetAddress ||
                !!gln.address?.countryCode ||
                !!gln.address?.postalCode ||
                !!gln.address?.addressLocality)">
            <p class="gs1-color-ui-6 gs1-little">Adresse physique</p>
            <p *ngIf="!!gln.address.streetAddress" class="gs1-color-blue gs1-little">
              {{ gln.address.streetAddress }}
            </p>
            <p *ngIf="
                gln.address.streetAddress2 &&
                gln.address.streetAddress2.length > 0
              " class="gs1-color-blue gs1-little">
              {{ gln.address.streetAddress2 }}
            </p>
            <p *ngIf="!!gln.address.postalCode || !!gln.address.addressLocality" class="gs1-color-blue gs1-little">
              {{ gln.address.postalCode }} {{ gln.address.addressLocality }}
            </p>
            <p *ngIf="!!countryName" class="gs1-color-blue gs1-little">
              {{ countryName }}
            </p>

            <br>
            <div class="gs1-form-group-part" *ngIf="!GLNForm">
              <p class="gs1-color-ui-6 gs1-little">
                Coordonnées GPS
                <i class="bi bi-question-circle-fill gs1-color-blue"
                  matTooltip="Automatiquement calculées à partir de l'adresse physique saisie."
                  [matTooltipPosition]="'above'"></i>
              </p>
              <p class="gs1-color-blue gs1-little">
                {{
                isGeolocalisationSet()
                ? formatGpsCord(gln.latitude)  + ", " + formatGpsCord(gln.longitude)
                : "Calcul des coordonnées GPS impossible. Veuillez corriger l'adresse physique renseignée."
                }}
              </p>
              <br/>
            </div>

          </div>
          <div *ngIf="isGoogleReady && isGlnMapVisible" class="mapDiv col-7">
             <google-map width="100%" height="100%" [options]="mapOptions" #glnMap>
              <map-marker [position]="marker.position"></map-marker>
           </google-map>
          </div>
        </div>
          <div class="gs1-form-group-part" *ngIf="GLNForm" [formGroup]="GLNForm">
            <div formGroupName="address">
              <gs1-input [hasState]="false" class="full-width" [name]="'streetAddress'" type="address"
                (onAddressChange)="AddressChange($event)" formControlName="streetAddress" [label]="'Adresse'">
              </gs1-input>
              <gs1-input [hasState]="false" class="full-width" [name]="'streetAddress2'"
                formControlName="streetAddress2" [label]="'Complément d\'adresse (optionnel)'">
              </gs1-input>
              <gs1-input [hasState]="false" [name]="'postalCode'" formControlName="postalCode" [label]="'Code postal'"
                class="postal-code"></gs1-input>
              <gs1-input [hasState]="false" [name]="'addressLocality'" formControlName="addressLocality"
                [label]="'Ville'" class="city">
              </gs1-input>
              <gs1-select-wrapper [hasState]="false" class="country">
                <label for="countryCode">Pays</label>
                <ng-select formControlName="countryCode" name="countryCode" [bindValue]="'Code alpha-2'"
                  [notFoundText]="'Aucun résultat trouvé'" [bindLabel]="'wording-fr'" [items]="countryList"
                  [searchable]="true" [multiple]="false" [closeOnSelect]="true" [hideSelected]="true">
                </ng-select>
              </gs1-select-wrapper>
            </div>
          </div>



          <div class="gs1-form-group-part" *ngIf="gln.url || gln.digitalAddress || GLNForm">

            <div class="full-width" *ngIf="gln.url && !GLNForm">
              <p class="gs1-color-ui-6 gs1-little">Site web</p>
              <p class="gs1-color-blue gs1-little">{{ gln.url }}</p>
              <br/>
            </div>

            <div *ngIf="GLNForm" [formGroup]="GLNForm">
              <gs1-input [label]="'Site web (optionnel)'" [hasState]="false" formControlName="url"
                [name]="'url'">
              </gs1-input>
            </div>
            <div class="full-width" *ngIf="
                !GLNForm &&
                gln.digitalAddress &&
                gln.digitalAddress.trim().length > 0
              ">
              <p class="gs1-color-ui-6 gs1-little">Adresse digitale
                <i class="bi bi-question-circle-fill gs1-color-blue"
                matTooltip="Adresse digitale qui permet d'identifier un lieu digital (Url, serveur informatique, code GLN, etc.)"
                [matTooltipPosition]="'above'"></i>
              </p>
              <p class="gs1-color-blue gs1-little">{{ gln.digitalAddress }}</p>
            </div>
            <div *ngIf="edit && GLNForm" [formGroup]="GLNForm">
              <gs1-input [hasState]="false" [name]="'digitalAddress'" formControlName="digitalAddress" [maxlength]="80">
                <label for="digitalAddress">Adresse digitale
                  <i class="bi bi-question-circle-fill gs1-color-blue"
                  matTooltip="Adresse digitale qui permet d'identifier un lieu digital (Url, serveur informatique, code GLN, etc.)"
                  [matTooltipPosition]="'above'"></i>
                  {{ isDigitalAdressRequired() ? "" : " (optionnel)" }}
                </label>
              </gs1-input>
            </div>
          </div>

        </gs1-form-group>


        <gs1-form-group [hasState]="false" [label]="'Informations entreprise'"
          *ngIf="gln.isMain === true || gln.roleType || GLNForm">
          <div class="gs1-form-group-part" *ngIf="gln.isMain === true">
            <div *ngIf="gln.companyName">
              <p class="gs1-color-ui-6 gs1-little">Raison sociale</p>
              <p class="gs1-color-blue gs1-little">{{ gln.companyName }}</p>
            </div>
            <div *ngIf="gln.siren">
              <p class="gs1-color-ui-6 gs1-little">SIREN</p>
              <p class="gs1-color-blue gs1-little">{{ gln.siren }}</p>
            </div>
            <div *ngIf="gln.codeNaf">
              <p class="gs1-color-ui-6 gs1-little">Code NAF</p>
              <p class="gs1-color-blue gs1-little">{{ gln.codeNaf }}</p>
            </div>
            <div *ngIf="gln.vatCode">
              <p class="gs1-color-ui-6 gs1-little">Numéro de TVA</p>
              <p class="gs1-color-blue gs1-little">{{ gln.vatCode }}</p>
            </div>
          </div>

          <div *ngIf="edit && GLNForm" [formGroup]="GLNForm" >
            <gs1-input class="internCode"
            *ngIf="shouldShowCodeNumber() && GLNForm.get('organisationCode')?.value === organisationCodes[1].value"
            [name]="'codeNumberIntern'" formControlName="codeNumberIntern" [placeholder]="'14 caractères maximum.'">
            <span slot="error" *ngIf="showError('codeNumberIntern')">Ce code n’est pas valide</span>
          </gs1-input>

            <gs1-input class="siret"
              *ngIf="shouldShowCodeNumber() && GLNForm.get('organisationCode')?.value  === organisationCodes[0].value"
              [name]="'codeNumberSiret'" formControlName="codeNumberSiret" [placeholder]="'14 chiffres.'">
              <span slot="error" *ngIf="showError('codeNumberSiret')">Ce code n'est pas correct</span>
            </gs1-input>

            <gs1-radios class="full-width" [label]="'Associez un code organisationnel à votre GLN (optionnel)'" style="white-space: nowrap;">


              <gs1-radio [value]="organisationCodes[0].value"
                         formControlName="organisationCode"
                         [name]="organisationCodes[0].label"
                         [label]="organisationCodes[0].label"></gs1-radio>


              <gs1-radio formControlName="organisationCode" [value]="organisationCodes[1].value"
                         [name]="organisationCodes[1].label"
                         [label]="organisationCodes[1].label">
              </gs1-radio>
            </gs1-radios>
          </div>

          <div *ngIf="gln.roleType && !GLNForm" class="full-width gs1-form-group-part">
            <p class="gs1-color-ui-6 gs1-little">Rôle du GLN</p>
            <p class="gs1-color-blue gs1-little">
              {{ getLabelForRoleType(gln.roleType) }}
            </p>
          </div>
          <div class="full-width gs1-form-group-part" *ngIf="GLNForm" [formGroup]="GLNForm">
            <gs1-select-wrapper [hasState]="false" class="full-width" >
              <label for="roleType">Rôle du GLN (optionnel)</label>
              <ng-select formControlName="roleType" name="roleType" [clearable]="true" [bindValue]="'value'" notFoundText="Aucun résultat trouvé"
                [bindLabel]="'label'" [items]="roleTypesListFilter" [searchable]="true" [multiple]="false"
                [closeOnSelect]="true" [ngClass]="initRoleType ? 'ng-select-focused': '' ">
              </ng-select>
            </gs1-select-wrapper>
          </div>
        </gs1-form-group>
      </div>
      <div class="column" [ngClass]="{'column-right' : !edit}"
       *ngIf="!GLNForm">
        <gs1-form-group [label]="'Contact associé'" [hasState]="false" *ngIf="
            gln.contact &&
            (gln.contact.lastName ||
              gln.contact.firstName ||
              gln.contact.email ||
              gln.contact.phone)
          ">
          <div class="gs1-form-group-part contact">
            <div *ngIf="gln.contact.lastName">
              <p class="gs1-color-ui-6 gs1-little">Nom</p>
              <p class="gs1-color-blue gs1-little">
                {{ gln.contact.lastName }}
              </p>
            </div>
            <div *ngIf="gln.contact.firstName">
              <p class="gs1-color-ui-6 gs1-little">Prénom</p>
              <p class="gs1-color-blue gs1-little">
                {{ gln.contact.firstName }}
              </p>
            </div>
            <div class="full-width" *ngIf="gln.contact.email">
              <p class="gs1-color-ui-6 gs1-little">Adresse mail</p>
              <p class="gs1-color-blue gs1-little">{{ gln.contact.email }}</p>
            </div>
            <div class="full-width" *ngIf="gln.contact.phone && gln.contact.phone.length >= 5">
              <p class="gs1-color-ui-6 gs1-little">Téléphone</p>
              <p class="gs1-color-blue gs1-little">
                {{ gln.contact.phone | phone }}
              </p>
            </div>
          </div>
        </gs1-form-group>
        <gs1-alert *ngIf="gln.isMain && !fromSearch" class="gs1-little"
          [title]="'Comment modifier mon GLN principal ?'">
          <span class="gs1-little">
            Vous pouvez mettre à jour les coordonnées et le contact de votre
            entreprise depuis <a href="{{ urlECLI }}" target="_blank">votre espace client</a>, si vous disposez des droits administrateur.
          </span>
        </gs1-alert>
      </div>
      <div class="column" *ngIf="GLNForm" [formGroup]="GLNForm">
        <gs1-form-group [label]="'Contact associé'" formGroupName="contact" [hasState]="false">
          <div class="gs1-form-group-part contact">
            <gs1-input [name]="'lastName'" formControlName="lastName" [label]="'Nom (optionnel)'"></gs1-input>
            <gs1-input [name]="'firstName'" formControlName="firstName" [label]="'Prénom (optionnel)'"></gs1-input>
            <gs1-input [name]="'email'" formControlName="email" [label]="'Email (optionnel)'"></gs1-input>
            <gs1-phone [name]="'phone'" formControlName="phone" [label]="'Téléphone (optionnel)'"></gs1-phone>
          </div>
        </gs1-form-group>
      </div>

      <ng-template #dialog class="background">
            <h3 matDialogTitle>Vous êtes sur le point de modifier les informations de ce GLN</h3>


           <mat-dialog-content style="font-weight:400" >
                  <p class="gs1-little">

               Changer l'adresse ou le nom d'un GLN n'est pas recommandé et est contraire
              <a target="_blank" href="https://www.gs1.fr/regles-codification-lieux-gln" target="_blank">
                aux règles de codification GS1
              </a>.
            </p>
            <p class="gs1-little">
              Nous vous recommandons d'en créer un nouveau avec les informations mises à jour.
            </p>
          </mat-dialog-content>
          <mat-dialog-actions>
            <button gs1Button [name]="'acceptModification'" (click)="acceptModification()" [thin]="true" [appearance]="'outlined'" matStepperNext type="button" style="font-size: 14px;">
              {{ "Continuer quand même" }}
            </button>
            <button gs1Button [name]="'refuseModification'" (click)="refuseModification()" [thin]="true"  matStepperPrevious type="button" style="font-size: 14px;">
              {{ "Annuler la modification" }}
            </button>
          </mat-dialog-actions>
       </ng-template>
    </div>
  </ng-container>
</ng-template>
